/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
// $(document).ready(function() {
//   var $slider = $(".Product__SlideshowNav.Product__SlideshowNav--thumbnails .Product__SlideshowNavScroller");
//   var flkty = Flickity.data(document.querySelector('.Product__Slideshow'));

//   var syncing = false;

//   $slider.on('afterChange', function(event, slick, currentSlide){
//     if(syncing) return;
//     syncing = true;

//     // Sync Flickity to Slick's current slide
//     flkty.select(currentSlide);

//     syncing = false;
//   });

//   // flkty.on('select', function() {
//   //   if(syncing) return;
//   //   syncing = true;

//   //   // Sync Slick to Flickity's current slide
//   //   $slider.slick('slickGoTo', flkty.selectedIndex);

//   //   syncing = false;
//   // });
//   $('.flickity-prev-next-button.previous').click(function(){
//     $('.Product__SlideshowNavArrow--previous.slick-arrow').click();
// })
// $('.flickity-prev-next-button.next').click(function(){
//     $('.Product__SlideshowNavArrow--next.slick-arrow').click();
// })
// });
// document.addEventListener('DOMContentLoaded', function () {
//   const flickity = new Flickity('.Product__Slideshow', {
//     prevNextButtons: true,
//     pageDots: false,
//     adaptiveHeight: true,
//     watchCSS: true,
//     dragThreshold: 8,
//     initialIndex: 0, 
//   });


//   const prevButton = document.querySelector('.flickity-prev-next-button.previous');
//   const nextButton = document.querySelector('.flickity-prev-next-button.next');
//   if (prevButton) {
//     prevButton.innerHTML = `
//       <svg role="presentation" viewBox="0 0 6 9">
//         <path d="M5 8.5l-4-4 4-4" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path>
//       </svg>
//     `;
//   }
//   if (nextButton) {
//     nextButton.innerHTML = `
//       <svg role="presentation" viewBox="0 0 6 9">
//         <path d="M1 8.5l4-4-4-4" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path>
//       </svg>
//     `;
//   }
// })



 




// jQuery(document).ready(function($) {
//   $('button.Collapsible__Button.Heading.u-h6.custom_product_tabs').trigger('click');
//   $('.Container.new-Brands-Logos').slick({
//     speed: 5000,
//     autoplay: true,
//     autoplaySpeed: 0,
//      pauseOnHover:false,
//     cssEase: 'linear',
//     slidesToShow: 6,
//     slidesToScroll: 1,
//     infinite: true,
//     initialSlide: 1,
//     arrows: false,
//     buttons: false,
//     responsive: [
//       {
//         breakpoint: 901,
//         settings: {
//           slidesToShow: 5,            
//         },
//       },
//       {
//         breakpoint: 501,
//         settings: {
//           slidesToShow: 3,            
//         },
//       },


//     ],
//   });



// if(window.innerWidth >= 768){

// $(".Product__SlideshowNav.Product__SlideshowNav--thumbnails .Product__SlideshowNavScroller").slick({
//         verticalSwiping: true,
        
//         vertical: true,
//     draggable: true,
//       infinite: true,
//        focusOnSelect: true,  
//       slidesToShow: 6,
//       slidesToScroll: 1,
//       prevArrow:"<button class='product-page-desktop Product__SlideshowNavArrow Product__SlideshowNavArrow--previous' type='button' data-direction='previous' aria-label='Previous'><svg class='Icon Icon--media-arrow-left' role='presentation' viewBox='0 0 6 9'><path d='M5 8.5l-4-4 4-4' stroke='currentColor' fill='none' fill-rule='evenodd' stroke-linecap='square'></path></svg></button>",
//       nextArrow:"<button class='product-page-desktop Product__SlideshowNavArrow Product__SlideshowNavArrow--next' type='button' data-direction='next' aria-label='Next'><svg class='Icon Icon--media-arrow-right' role='presentation' viewBox='0 0 6 9'><path d='M1 8.5l4-4-4-4' stroke='currentColor' fill='none' fill-rule='evenodd' stroke-linecap='square'></path></svg></button>",
//       dots: false,
//       asNavFor: '.Product__Slideshow', 
//     });
//   }
// if (window.innerWidth < 768) {
//   const flkty = new Flickity('.Product__SlideshowNav.Product__SlideshowNav--thumbnails .Product__SlideshowNavScroller', {
//     pageDots: false,
//     prevNextButtons: false,
//     draggable: true,
//     wrapAround: true,
//     cellAlign: 'left',       // Align slides to left
//     contain: true  ,
//     asNavFor: '.Product__Slideshow',
//     arrowShape: {
//       x0: 10,
//       x1: 60, y1: 50,
//       x2: 70, y2: 40,
//       x3: 30
//     },
//     axis: 'x',
//     initialIndex: 0 
//   });

//   let isDragging = false;

//   flkty.on('dragStart', function () {
//     isDragging = true;
//   });

//   flkty.on('select', function () {
  
//     flkty.cells.forEach(cell => {
//       cell.element.classList.remove('is-selected');
//     });

//     if (!isDragging) {
//       flkty.selectedElement.classList.add('is-selected');
//     }
//   });

//   flkty.on('dragEnd', function () {
//     isDragging = false;
//   });

//   flkty.selectedElement.classList.add('is-selected');
// }


// });
// function myFunction() {
//   var element = document.getElementById("myDIV");
//   element.style.display = "none";
// }  
      
// //       Custom js for tag tree
//       $("#BlogTagFilter").change(function(){
//       var url=$("#BlogTagFilter option:selected").val();
//       window.location.href= url;
//       });
      
      
//       $("button.product_page_fm_btn").click(function(){
// $(".main_ask_a_question_overlay").show();

// });

// $(document).ready(function () {
// if($("body").hasClass("custom-template-combine-product")){

// document.addEventListener("variant:changed", function (evt) {
//     console.log("Product variant changed");
//     $(".pswp.pswp--open").removeClass("pswp--open");
//     // console.log(evt.detail.variant);
//     const variant_obj = evt.detail.variant
//     console.log("variant_obj",variant_obj);
//     const variant_title = variant_obj.title;
//     console.log("variant_title",variant_title);
//     getVariantImages();
// });
// getVariantImages();
// }
// });

// function getVariantImages(){
// var option1 = $(".SizeSwatch__Radio[data-option-position='1']:checked").val();
// var option2 = $(".SizeSwatch__Radio[data-option-position='2']:checked").val();
// console.log(option1+"====="+option2);
// var title = option1;
// var title1 = option1+"/"+option2;
// console.log(title);
// var main_imageHTML = '';
// var thumbnail_imagesHTML = '';
// var x= 1;
// $(".cstm-all-images .cstm-image-test").each(function(index){
//   var alt = $(this).attr("data-alt");
//   var main_image = $(this).attr("data-main-img");
//   var thumbnail_image = $(this).attr("data-thumbnail-img");
//  var media_id = $(this).attr("data-media-id");
 
//     var alt = $(this).attr("data-alt");
//  console.log(alt+"====="+option1+"============="+option2);
//   if($.trim(alt) == $.trim(title) || $.trim(alt) == $.trim(title1)){
//      main_imageHTML +="<div data-media-type='image' class='Product__SlideItem Product__SlideItem--image' data-media-position='"+x+"'><img src='"+main_image+"' alt='"+alt+"' data-max-width='800' data-max-height='800'  /></div>";
//     thumbnail_imagesHTML +="<div data-media-id='"+media_id+"' class='Product__SlideshowNavImage'><img src='"+thumbnail_image+"' alt='"+alt+"'/></div>";
//   x++;
//   }else if($.trim(alt).indexOf(option1) > -1 && $.trim(alt).indexOf(option2) > -1 ){
//      main_imageHTML +="<div data-media-type='image' class='Product__SlideItem Product__SlideItem--image' data-media-position='"+x+"'><img src='"+main_image+"' alt='"+alt+"' data-max-width='800' data-max-height='800'  /></div>";
//     thumbnail_imagesHTML +="<div data-media-id='"+media_id+"' class='Product__SlideshowNavImage'><img src='"+thumbnail_image+"' alt='"+alt+"'/></div>";
//     x++;
//   }
  
// });
// if(x==1){
// $(".cstm-all-images .cstm-image-test").each(function(index){
//   var alt = $(this).attr("data-alt");
//   var main_image = $(this).attr("data-main-img");
//   var thumbnail_image = $(this).attr("data-thumbnail-img");
//  var media_id = $(this).attr("data-media-id");
//     main_imageHTML +="<div data-media-type='image' class='Product__SlideItem Product__SlideItem--image' data-media-position='"+x+"'><img src='"+main_image+"' alt='"+alt+"' data-max-width='800' data-max-height='800'  /></div>";
//     thumbnail_imagesHTML +="<div data-media-id='"+media_id+"' class='Product__SlideshowNavImage'><img src='"+thumbnail_image+"' alt='"+alt+"'/></div>";
//   x++;  
// });
//   }

// destroyProductSlideshow();

// $(".Product__Slideshow").html(main_imageHTML);
// $(".Product__SlideshowNavScroller").html(thumbnail_imagesHTML);
// setTimeout(function(){
// initProductSlideshow();

// },500);

// }

// function destroyProductSlideshow() {
//   if ($('.Product__Slideshow').hasClass('slick-initialized')) {
//     $('.Product__Slideshow').slick('unslick');
//   }

//   const $navScroller = $(".Product__SlideshowNav.Product__SlideshowNav--thumbnails .Product__SlideshowNavScroller");
//   if ($navScroller.hasClass('slick-initialized')) {
//     $navScroller.slick('unslick');
//   }
// }

// function initProductSlideshow() {
//    const $mainSlider = $('.Product__Slideshow');
//   const $navSlider = $(".Product__SlideshowNavScroller");

//   // Destroy old sliders if needed
//   if ($mainSlider.hasClass('slick-initialized')) $mainSlider.slick('unslick');
//   if ($navSlider.hasClass('slick-initialized')) $navSlider.slick('unslick');

//   $mainSlider.slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     infinite:false,
//     arrows: true,
//     fade: false,
//     prevArrow: '<button class="slick-prev custom-prev" aria-label="Previous"><svg role="presentation" viewBox="0 0 6 9"><path d="M5 8.5l-4-4 4-4" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path></svg></button>',
//     nextArrow: '<button class="slick-next custom-next" aria-label="Next"><svg role="presentation" viewBox="0 0 6 9"><path d="M1 8.5l4-4-4-4" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path></svg></button>',
//     asNavFor: '.Product__SlideshowNavScroller'
//   });

//   $navSlider.slick({
//     verticalSwiping: true,
//     infinite:false,
//     vertical: true,
//     draggable: true,
//     focusOnSelect: true,
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     prevArrow:"<button class='product-page-desktop Product__SlideshowNavArrow Product__SlideshowNavArrow--previous' type='button' data-direction='previous' aria-label='Previous'><svg class='Icon Icon--media-arrow-left' role='presentation' viewBox='0 0 6 9'><path d='M5 8.5l-4-4 4-4' stroke='currentColor' fill='none' fill-rule='evenodd' stroke-linecap='square'></path></svg></button>",
//     nextArrow:"<button class='product-page-desktop Product__SlideshowNavArrow Product__SlideshowNavArrow--next' type='button' data-direction='next' aria-label='Next'><svg class='Icon Icon--media-arrow-right' role='presentation' viewBox='0 0 6 9'><path d='M1 8.5l4-4-4-4' stroke='currentColor' fill='none' fill-rule='evenodd' stroke-linecap='square'></path></svg></button>",
//     dots: false,
//     asNavFor: '.Product__Slideshow'
//   });
 
// // Wait for Slick to render slides
//   $mainSlider.on('init', function (event, slick) {
//     console.log("Event",event);
//     console.log("slick",slick);
    
//     initPhotoSwipeForSlider(event.target.slick); // safe to init here
//   });

  
// }


// // $('.Product__Slideshow--zoomable').click(function(){
// //   const $mainSlider1 = $('.Product__Slideshow');
// //       $mainSlider1.on('init', function (event, slick) {
// //     console.log("Event",event);
// //     console.log("slick",slick);
// //     initPhotoSwipeForSlider(event.target.slick); // safe to init here
// //   });

// // });


// function initPhotoSwipeForSlider(slick) {
//   // Use only *original* slides, not cloned ones (targets Product__SlideItem images)
//   var $slides = $(slick.$slides).not('.slick-cloned').find('img');

//   console.log('Found slides:', $slides.length);

//   if ($slides.length === 0) {
//     console.warn('No images found in slider for PhotoSwipe.');
//     return;
//   }

//   // Remove old handlers to avoid duplicates
//   $slides.off('click.photoswipe');

//   $slides.each(function(index) {
//     // Capture index in closure for the click handler
//     (function(idx) {
//       $(this).on('click.photoswipe', function(e) {
//         e.preventDefault();
//         e.stopPropagation();

//         // NEW: Guard against synthetic/auto events during variant rebuild (rare, but prevents glitches)
//         if (e.isTrigger) {  // jQuery detects synthetic triggers
//           console.log('Ignoring synthetic click during init');
//           return;
//         }

//         var items = [];

//         $(slick.$slides).not('.slick-cloned').find('img').each(function() {
//           var $img = $(this);
//           if (this.complete) {
//             items.push({
//               src: $img.attr('src'),
//               w: this.naturalWidth || 1200,
//               h: this.naturalHeight || 800,
//               title: $img.attr('alt') || ''
//             });
//           } else {
//             items.push({
//               src: $img.attr('src'),
//               w: 1200,
//               h: 800,
//               title: $img.attr('alt') || ''
//             });
//           }
//         });

//         const pswpElement = document.querySelector('.pswp');
//         if (!pswpElement) {
//           console.error('PhotoSwipe container (.pswp) not found!');
//           return;
//         }

//         const options = {
//           index: idx,
//           escKey: true,
//           arrowKeys: true,
//           focus: false,  // Prevents focus-triggered reopens
//         };

//         // FIXED: Use PhotoSwipeUI_Default for arrows/close (assumes script loaded; fallback to false)
//         const pswp = new PhotoSwipe(pswpElement, false, items, options);  // Fallback if UI not loaded
//         pswp.listen('destroy', function() {
//           this.currItem?.container?.querySelector('img')?.blur();
//           console.log('PhotoSwipe destroyed – focus cleared');
//         });
//         pswp.init();

//         // FIXED: Only show UI if it exists (with false, this does nothing)
//         const $ui = $('.pswp__ui');
//         if ($ui.length) {
//           $ui.removeClass('pswp__ui--hidden');
//         }

//         // NEW: Custom close button handler – bind after init
//         const $closeButton = $('.pswp__button--close');
//         $closeButton.off('click.customclose').on('click.customclose', function(e) {
//           e.preventDefault();
//           e.stopPropagation();
          
//           // Your requested action: Remove pswp--open class
//           $('.pswp.pswp--open').removeClass('pswp--open');
          
//           // RECOMMENDED: Also call full close for cleanup (unbinds events, etc.)
//           // Comment out if you truly want only class removal
//           pswp.close();
          
//           console.log('Custom close triggered – class removed');
//         });
        
//       });
//     })(index);
//   });
// }





/* Start Fully Corrcected code */

jQuery(document).ready(function ($) {
  // Existing code unchanged
  $('button.Collapsible__Button.Heading.u-h6.custom_product_tabs').trigger('click');

  $('.Container.new-Brands-Logos').slick({
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    pauseOnHover: false,
    cssEase: 'linear',
    slidesToShow: 6,
    slidesToScroll: 1,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 901,
        settings: { slidesToShow: 5 },
      },
      {
        breakpoint: 501,
        settings: { slidesToShow: 3 },
      },
    ],
  });

  if (window.innerWidth >= 768) {
    $(".Product__SlideshowNav.Product__SlideshowNav--thumbnails .Product__SlideshowNavScroller").slick({
      verticalSwiping: true,
      vertical: true,
      draggable: true,
      infinite: true,
      focusOnSelect: true,
      slidesToShow: 6,
      slidesToScroll: 1,
      prevArrow: "<button class='product-page-desktop Product__SlideshowNavArrow Product__SlideshowNavArrow--previous'><svg viewBox='0 0 100 100'><path d='M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z' class='arrow'></path></svg></button>",
      nextArrow: "<button class='product-page-desktop Product__SlideshowNavArrow Product__SlideshowNavArrow--next'><svg viewBox='0 0 100 100'><path d='M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z' class='arrow' transform='translate(100, 100) rotate(180)'></path></svg></button>",
      // asNavFor: '.Product__Slideshow'
    });
  }

  if (window.innerWidth < 768) {
    const flkty = new Flickity('.Product__SlideshowNav.Product__SlideshowNav--thumbnails .Product__SlideshowNavScroller', {
      pageDots: false,
      prevNextButtons: false,
      draggable: true,
      wrapAround: true,
      cellAlign: 'left',
      contain: true,
      asNavFor: '.Product__Slideshow',
      axis: 'x',
      initialIndex: 0
    });

    let isDragging = false;

    flkty.on('dragStart', function () { isDragging = true; });
    flkty.on('dragEnd', function () { isDragging = false; });

    flkty.on('select', function () {
      flkty.cells.forEach(cell => cell.element.classList.remove('is-selected'));
      if (!isDragging) {
        flkty.selectedElement.classList.add('is-selected');
      }
    });

    flkty.selectedElement.classList.add('is-selected');
  }

  window.myFunction = function () {
    document.getElementById("myDIV").style.display = "none";
  };

  $("#BlogTagFilter").change(function () {
    var url = $("#BlogTagFilter option:selected").val();
    window.location.href = url;
  });

  $("button.product_page_fm_btn").click(function () {
    $(".main_ask_a_question_overlay").show();
  });

  if ($("body").hasClass("custom-template-combine-product")) {
    var pswpInstanceJTPL = null; 
    document.addEventListener("variant:changed", function (evt) {
      console.log("Product variant changed");
      pswpInstanceJTPL = null; 
      $(".pswp.pswp--open").removeClass("pswp--open");
      var variant_obj = evt.detail.variant;
      console.log("variant_obj", variant_obj);
      getVariantImages();
    });
    getVariantImages();
  }

  document.addEventListener('reinit-photo-zoom', function () {
    var slick = $('.Product__Slideshow').slick('getSlick');
    if (slick) initPhotoSwipeZoom(slick);
  });

  // New: Social share toggle functionality for mobile
  if ($("body").hasClass("custom-template-combine-product") && window.matchMedia('(max-width: 767px)').matches) {
  $('[data-action="toggle-social-share"]').on('click.socialShare', function (e) {
    e.preventDefault();
    var $target = $(this);
    $target.toggleClass('is-active RoundButton--secondaryState');
    $target.attr('aria-expanded', $target.attr('aria-expanded') === 'true' ? 'false' : 'true');
    $target.next().attr('aria-hidden', $target.next().attr('aria-hidden') === 'true' ? 'false' : 'true');
  });
}

  function getVariantImages() {
    var option1 = $(".jtpl_wrap_button input[type=radio][data-option-position='1']:checked").val();
    var option2 ='';
    if($(".jtpl_wrap_button input[type=radio][data-option-position='2']").length > 0){
      var option2 = $(".jtpl_wrap_button input[type=radio][data-option-position='2']:checked").val();   
    }else{
      option2 = option1;
    }
    var title = option1;
    var title1 = option1 + "/" + option2;

    var main_image = "";
    var thumbnail_images = "";
    var x = 1;

    $(".cstm-all-images .cstm-image-test").each(function () {
      var alt = $(this).attr("data-alt").trim();
      var main_image_src = $(this).attr("data-main-img");
      var thumbnail_image_src = $(this).attr("data-thumbnail-img");
      var media_id = $(this).attr("data-media-id");
      var filename = $(this).attr("data-filename");
        console.log(alt+"========"+option1+"=========="+option2)
     
      if (alt.indexOf(option1) > -1 && alt.indexOf(option2) > -1) {
      // if ((" " + alt + " ").includes(" " + option1 + " ") && (" " + alt + " ").includes(" " + option2 + " ")) {
        //     let tokens = alt
        //   .toLowerCase()
        //   .split(/[\s\/\-]+/)     // split by space, slash, hyphen
        //   .filter(Boolean);

        // let opt1 = option1.toLowerCase();
        // let opt2 = option2.toLowerCase();

        // if (tokens.includes(opt1) && tokens.includes(opt2)) {

        console.log(alt+"========"+option1+"=========="+option2)
        main_image += `<div data-media-type='image' class='Product__SlideItem Product__SlideItem--image' data-media-position='${x}'><div class="zoom-icon" data-action="open-product-zoom"></div><img src='${main_image_src}' alt='${alt}' data-max-width='800' data-max-height='800' /></div>`;
        thumbnail_images += `<div data-media-id='${media_id}' class='Product__SlideshowNavImage'><img src='${thumbnail_image_src}' alt='${alt}'/></div>`;
        x++;
      }
    });

    if (x === 1) {
      $(".cstm-all-images .cstm-image-test").each(function () {
        var alt = $(this).attr("data-alt").trim();
        var main_image_src = $(this).attr("data-main-img");
        var thumbnail_image_src = $(this).attr("data-thumbnail-img");
        var media_id = $(this).attr("data-media-id");

        main_image += `<div data-media-type='image' class='Product__SlideItem Product__SlideItem--image' data-media-position='${x}'><div class="zoom-icon" data-action="open-product-zoom"></div><img src='${main_image_src}' alt='${alt}' data-max-width='800' data-max-height='800' /></div>`;
        thumbnail_images += `<div data-media-id='${media_id}' class='Product__SlideshowNavImage'><img src='${thumbnail_image_src}' alt='${alt}'/></div>`;
        x++;
      });
    }

    destroyProductSlideshow();
    $(".Product__Slideshow").html(main_image);
    $(".Product__SlideshowNavScroller").html(thumbnail_images);

    setTimeout(function () {
      initProductSlideshow();
    }, 500);
  }

  function destroyProductSlideshow() {
    if ($('.Product__Slideshow').hasClass('slick-initialized')) {
      $('.Product__Slideshow').slick('unslick');
    }

    var $navScroller = $(".Product__SlideshowNav.Product__SlideshowNav--thumbnails .Product__SlideshowNavScroller");
    if ($navScroller.hasClass('slick-initialized')) {
      $navScroller.slick('unslick');
    }
  }

  function initProductSlideshow() {
    pswpInstanceJTPL = null; 
    var $mainSlider = $('.Product__Slideshow');
    var $navSlider = $(".Product__SlideshowNavScroller");

    if ($mainSlider.hasClass('slick-initialized')) $mainSlider.slick('unslick');
    if ($navSlider.hasClass('slick-initialized')) $navSlider.slick('unslick');

    $mainSlider.on('init', function (event, slick) {
      initPhotoSwipeZoom(slick);
    });

    $mainSlider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      arrows: true,
      fade: false,
      prevArrow: '<button class="slick-prev custom-prev" aria-label="Previous"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></button>',
      nextArrow: '<button class="slick-next custom-next" aria-label="Next"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
      asNavFor: '.Product__SlideshowNavScroller'
    });

    $navSlider.slick({
      verticalSwiping: true,
      infinite: false,
      vertical: true,
      draggable: true,
      focusOnSelect: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow: "<button class='product-page-desktop Product__SlideshowNavArrow Product__SlideshowNavArrow--previous'><svg viewBox='0 0 100 100'><path d='M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z' class='arrow'></path></svg></button>",
      nextArrow: "<button class='product-page-desktop Product__SlideshowNavArrow Product__SlideshowNavArrow--next'><svg viewBox='0 0 100 100'><path d='M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z' class='arrow' transform='translate(100, 100) rotate(180)'></path></svg></button>",
      asNavFor: '.Product__Slideshow'
    });
  }

  function initPhotoSwipeZoom(slick) {
    $(slick.$slides).not('.slick-cloned').find('img').off('click.photoswipe').on('click.photoswipe', function (e) {
      if (e.isTrigger) return;
      e.preventDefault();

      var $images = $(slick.$slides).not('.slick-cloned').find('img');
      var items = [];

      $images.each(function () {
        var maxWidth = parseInt($(this).attr('data-max-width')) || 800;
        var maxHeight = parseInt($(this).attr('data-max-height')) || 800;
        var maxDimension = window.innerWidth <= 767 ? 1200 : 1800;
        var reduceFactor = Math.max(maxWidth >= maxHeight ? maxWidth / maxDimension : maxHeight / maxDimension, 1.0);
        var requestedWidth = Math.floor(maxWidth / reduceFactor);
        var requestedHeight = Math.floor(maxHeight / reduceFactor);

        items.push({
          src: $(this).attr('src'),
          w: requestedWidth,
          h: requestedHeight,
          msrc: $(this).attr('src'),
          initialZoomLevel: 0.65,
          title: $(this).attr('alt') || ''
        });
      });

      var clickedIndex = $images.index(this);

      var pswpElement = document.querySelector('.pswp');
      if (!pswpElement) {
        console.error('PhotoSwipe container (.pswp) not found!');
        return;
      }

      console.log("ClickedIndex..."+clickedIndex);
      
      var options = {
        index: clickedIndex,
        showHideOpacity: true,
        showAnimationDuration: 500,
        loop: false,
        history: false,
        closeOnVerticalDrag: false,
        allowPanToNext: false,
        pinchToClose: false,
        errorMsg: '<p class="pswp__error-msg">' + (window.languages?.productImageLoadingError || 'Error loading image') + '</p>',
        scaleMode: 'zoom',
        getDoubleTapZoom: function (isMouseClick, item) {
          if (isMouseClick) {
            return 1.6;
          } else {
            return item.initialZoomLevel < 0.7 ? 1 : 1.33;
          }
        },
        getThumbBoundsFn: function (index) {
          var $thumbnail = $('.Product__SlideshowNavScroller .Product__SlideshowNavImage:nth-child(' + (index + 1) + ') img');
          if ($thumbnail.length) {
            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            var rect = $thumbnail[0].getBoundingClientRect();
            return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
          }
          return { x: 0, y: 0, w: 0 };
        }
      };

      pswpInstanceJTPL = new PhotoSwipe(pswpElement, PhotoSwipe.UI_Default, items, options);
      
      pswpInstanceJTPL.listen('beforeChange', function () {
        var currentIndex = pswpInstanceJTPL.getCurrentIndex();
        var $prevBtn = pswpInstanceJTPL.scrollWrap.querySelector('.pswp__button--prev');
        var $nextBtn = pswpInstanceJTPL.scrollWrap.querySelector('.pswp__button--next');
        
        if (currentIndex === 0) {
          $prevBtn.setAttribute('disabled', 'disabled');
        } else {
          $prevBtn.removeAttribute('disabled');
        }
        if (currentIndex + 1 === items.length) {
          $nextBtn.setAttribute('disabled', 'disabled');
        } else {
          $nextBtn.removeAttribute('disabled');
        }
      });

      pswpInstanceJTPL.listen('destroy', function () {
        $(document).off('.pswpCustom');
        pswpInstanceJTPL = null;
      });

      pswpInstanceJTPL.listen('doubleTap', function (point) {
        var initialZoomLevel = pswpInstanceJTPL.currItem.initialZoomLevel;
        if (pswpInstanceJTPL.getZoomLevel() !== initialZoomLevel) {
          pswpInstanceJTPL.zoomTo(initialZoomLevel, point, 333);
        } else {
          pswpInstanceJTPL.zoomTo(initialZoomLevel < 0.7 ? 1 : 1.33, point, 333);
        }
      });

      pswpInstanceJTPL.listen('initialZoomIn', function () {
        document.querySelector('.pswp__ui').classList.remove('pswp__ui--hidden');
      });

      pswpInstanceJTPL.listen('initialZoomOut', function () {
        document.querySelector('.pswp__ui').classList.add('pswp__ui--hidden');
      });

      $(document).off('click.pswpCustom touchend.pswpCustom');
      
      $(document).on('click.pswpCustom', '.pswp__scroll-wrap', function (e) {
        var $target = $(e.target);
        if ($target.hasClass('pswp__img') && !window.matchMedia('(max-width: 767px)').matches) {
          pswpInstanceJTPL.toggleDesktopZoom(e.originalEvent?.releasePoint);
        } else if (!$target.hasClass('pswp__button')) {
          $('.pswp__ui').toggleClass('pswp__ui--hidden');
        }
      });

      $(document).on('touchend.pswpCustom', '.pswp__scroll-wrap', function (e) {
        var $target = $(e.target);
        if (!$target.hasClass('pswp__button')) {
          $('.pswp__ui').toggleClass('pswp__ui--hidden');
        }
      });

      $(document).on('click.pswpCustom touchend.pswpCustom', '.pswp__button--close', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (pswpInstanceJTPL) {
          pswpInstanceJTPL.close();
        }
      });

      $(document).on('click.pswpCustom touchend.pswpCustom', '.pswp__button--prev', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (pswpInstanceJTPL && !$(this).prop('disabled')) {
          pswpInstanceJTPL.prev();
        }
      });

      $(document).on('click.pswpCustom touchend.pswpCustom', '.pswp__button--next', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (pswpInstanceJTPL && !$(this).prop('disabled')) {
          pswpInstanceJTPL.next();
        }
      });

      $('.pswp__button--close, .pswp__button--prev, .pswp__button--next').on('touchstart', function(e) {
        e.preventDefault();
      });

      if (window.matchMedia('(max-width: 767px)').matches) {
        let touchStartX = 0;
        let touchEndX = 0;

        $(pswpElement).on('touchstart.pswpMobile', function(e) {
          touchStartX = e.originalEvent.touches[0].clientX;
        });

        $(pswpElement).on('touchend.pswpMobile', function(e) {
          touchEndX = e.originalEvent.changedTouches[0].clientX;
          handleSwipe();
        });

        function handleSwipe() {
          const swipeThreshold = 50;
          const diff = touchStartX - touchEndX;
          if (Math.abs(diff) > swipeThreshold) {
            if (diff > 0 && !$('.pswp__button--prev').prop('disabled')) {
              pswpInstanceJTPL.prev();
            } else if (diff < 0 && !$('.pswp__button--next').prop('disabled')) {
              pswpInstanceJTPL.next();
            }
          }
        }
      }

      pswpInstanceJTPL.init();
      setTimeout(function() {
        $('.pswp__button--close, .pswp__button--prev, .pswp__button--next').css({
          'pointer-events': 'auto',
          'touch-action': 'manipulation'
        });
      }, 100);
    });
  }
});

/* End Code*/ 


